<template>
  <div class="mb-2 pb-2">
    <h4 class="font-weight-bold">
      <i class="far fa-credit-card fa-lg mr-2 text-primary"></i>Select Card
    </h4>
    <p v-if="blurb" class="mb-0 text-size-small text-dark">{{blurb}}</p>
    <hr class="mt-1 mb-2">
    <div class="card-list-item form-check" v-for="card in cards" :key="card.id">
      <input type="radio" name="payment_method" class="form-check-input" :id="card.id" :value="card.id" v-model="form.stripe_payment_method" @change="setPayment($event, card.id)"/>
      <label :for="card.id">
      <img :src="card.cc_image_url" alt="{{ card.brand }}" width="32"/> ending in {{ card.last4 }}</label>

      <div class="float-right" v-if="has_linked">
        
        <label for="allow_payment_switch">Share with My Trucks</label>
        <InputSwitch v-model="card.mtd_shared_stripe_share_this_method" inputId="allow_payment_switch" @change="toggleShared(card)"/> 
      </div>
      <div class="float-right" v-else-if="card.mtd_shared_stripe_share_this_method">Shared</div>
      <div v-if="trash && !card.mtd_shared_stripe_share_this_method" class="float-right">
        <button :disabled="cardProcessing" class="btn btn-link text-secondary p-0" @click="deleteCard(card)">
          <i class="text-gray item-icon fas fa-trash pl-3"></i>
        </button>
      </div>
    </div>
    <jet-add-button modalTarget="#cardModal">New Card</jet-add-button>
  </div>
</template>

<script>
 import JetAddButton from '@/Jetstream/AddButton'
import InputSwitch from 'primevue/inputswitch';

  export default {
    data() {
      return {
        cardProcessing: false
      }
    },
    components: {
      JetAddButton,
      InputSwitch,
    },
    props: {
      cards: Array,
      form: Object,
      blurb: String,
      trash: {
        type: Boolean,
        default: true
      },
      has_linked: {
        type: Boolean,
        default: false
      },
    },
    methods: {
      deleteCard(card) {
        this.cardProcessing = true
        this.$inertia.visit(route('cart.deleteMethod', card), {
          onSuccess: () => this.cardProcessing = false,
          onFinish: () => this.cardProcessing = false,
          preserveScroll: true
        })
      },
      setPayment(e, id) {
        this.$emit('setPayment', e, id)
      },
      toggleShared(card) {
        this.cardProcessing = true
        this.$inertia.visit(route('mtd.method.toggleshared', card), {
          onSuccess: () => this.cardProcessing = false,
          onFinish: () => this.cardProcessing = false,
          preserveScroll: true
        })
      }
    }
  }
</script>
